import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class Index extends Route {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @service declare headData: any;
  afterModel() {
    this.headData.title = 'Développeur de solutions digitales';
    this.headData.description =
      'TRIPTYK est votre agence de solutions digitales, de consultance et de formation aux métiers du web.';
    this.headData.image =
      'https://triptyk.eu/assets/images/triptyk-website.png';
    this.headData.url = 'https://triptyk.eu';
    this.headData.setStructuredSchemaForHome();
  }
}
